<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card
          class="mx-auto d-print-none"
          style="border: darkgreen 2px solid;background-color: linen"
      >
        <v-card-title>
          <v-icon
              large
              left
          >
            mdi-file-edit
          </v-icon>
          <p>ตั้งค่าข้อมูลรายละเอียดค่าใช้จ่าย (<span
              style="font-weight: bold;color: #ff6d81">{{ appHeaderName }}</span>)</p>
        </v-card-title>

        <v-card-text class="headline font-weight-bold">
          <v-list>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="6"
                    class="d-flex justify-center"
                >
                  <v-btn
                      outlined
                      :color="appColor"
                      @click="ChooseProcess('1')"
                  >
                    โครงการ
                  </v-btn>
                </v-col>
                <v-col
                    cols="12"
                    md="6"
                    class="d-flex justify-center"
                >
                  <v-btn
                      outlined
                      :color="appColor"
                      @click="ChooseProcess('2')"
                  >
                    อบรม / เดินทางไปปฏิบัติราชการ
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item>
            <v-divider class="pa-5"></v-divider>
            <v-list-item>
              <v-spacer></v-spacer>
              <v-text-field label="ค้นหารายการค่าใช้จ่าย" v-model="search"></v-text-field>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col
                  cols="12"
                  md="6"
                >
                  <p class="font-weight-bold">
                    ระบุรายละเอียดค่าใช้จ่าย
                  </p>
                  <v-text-field label="รายละเอียดค่าใช้จ่าย" v-model="expenseDetail"></v-text-field>
                  <div align="center">
                    <v-btn :color="appColor" dark @click="insertData">
                      เพิ่มค่าใช้จ่าย
                    </v-btn>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <p class="font-weight-bold">
                    ลิสต์รายการค่าใช้จ่าย
                  </p>
                  <v-data-table
                    :headers="headerTbl"
                    :items="expenseDataDump"
                    :search="search"
                  >
                    <template v-slot:header.cost_des>
                      <span style="font-size: 16px;font-weight: bold">รายละเอียดค่าใช้จ่าย</span>
                    </template>
                    <template v-slot:header.action>
                      <span style="font-size: 16px;font-weight: bold">ทำรายการ</span>
                    </template>
                    <template v-slot:item.action="{item}">
                      <v-btn text color="primary" class="darken-4 pa-2 font-weight-bold" @click="editData(item)">แก้ไข</v-btn>
                      <v-btn text color="red" class="darken-4 pa-2  font-weight-bold" @click="delData(item)">ลบ</v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-card-text>

      </v-card>
    </template>
    <template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Loading.....
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogProcess"
          max-width="1000"
          persistent>
        <v-card>
          <v-card-title>
            <span style="font-weight: bold">
              กรุณาเลือกประเภทก่อนทำรายการ
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt12">
            <row class="d-flex justify-center mt-12">
              <v-col
                  cols="12"
                  md="6"
                  class="d-flex justify-center"
              >
                <v-btn class="font-weight-bold pa-12" color="primary" @click="ChooseProcess('1')">
                  <span style="font-size: 20px">โครงการ</span>
                </v-btn>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
                  class="d-flex justify-center"
              >
                <v-btn class="font-weight-bold pa-12" color="#004D40" dark @click="ChooseProcess('2')">
                  <span style="font-size: 20px">อบรม / เดินทางไปปฏิบัติราชการ</span>
                </v-btn>
              </v-col>
            </row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogEdit"
          max-width="700"
          persistent>
        <v-card>
          <v-card-title>
            <span style="font-weight: bold">
              แก้ไขข้อมูลรายการค่าใช้จ่าย
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt12">
            <row class="d-flex justify-center mt-12">
              <v-col
                  cols="12"
                  md="12"
                  class="d-flex justify-center"
              >
                <v-text-field outlined v-model="cost_desc_edit" label="รายละเอียด"></v-text-field>
              </v-col>
            </row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined @click="execEditData" color="green">บันทึก</v-btn>
            <v-btn text color="red" @click="dialogEdit = false">ยกเลิก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import Const from "@/const/Const";
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";

export default {
  name: "SettingExpenses",
  data() {
    return {
      expenseObj: null,
      dialogEdit: false,
      dialogProcess: false,
      expenseDetail: '',
      search: '',
      cost_desc_edit: '',
      expenseDataDump: [],
      headerTbl: [
        {text: 'รายละเอียดค่าใช้จ่าย', value: 'cost_desc'},
        {text: 'ทำรายการ', value: 'action'},
      ],
      maintain: false,
      page: null,
      dialogLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      DateForPlan: 'Project/getDateForPlan',
      TypeProject: 'Project/getTypeProject',
      expense_Data: 'Project/getExpense',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    }),
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      initDateForPlan: 'Project/initDateForPlan',
      changeTypeProject: 'Project/changeTypeProject',
      initExpenseData: 'Project/initExpenseData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
    }),
    insertData() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "ต้องการเพิ่มรายการค่าใช้จ่าย " + this.expenseDetail + " (" + this.appHeaderName + " ) ใช่หรือไม่ ?" ,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          if (this.expenseDetail == '') {
            this.$swal.fire({
              icon: 'error',
              title: 'รายละเอียดค่าใช้จ่ายห้ามเป็นค่าว่าง !!'
            })
          } else {
            this.dialogLoading = true
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_cost_project/', {
              cost_desc: this.expenseDetail,
              cost_type: this.page,
              create_by: this.MeData[0].perid,
              create_time: 'now()'
            }, {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }).then(async res => {
              if (res.data) {
                this.expenseDetail = ''
                const resExpense = await this.initExpenseData({
                  cost_type: this.TypeProject
                })
                if (resExpense) {
                  this.dialogLoading = false
                  this.ChooseProcess(this.page)
                } else {
                  this.dialogLoading = false
                }
                this.$swal.fire({
                  icon: 'success',
                  title: 'เพิ่มข้อมูลสำเร็จ !!'
                })
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถเพิ่มข้อมูลได้ โปรดลองอีกครั้ง !!'
                })
              }
            })
          }
        }
      })
    },
    execEditData() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          if (this.cost_desc_edit == '') {
            this.$swal.fire({
              icon: 'error',
              title: 'รายละเอียดค่าใช้จ่ายห้ามเป็นค่าว่าง !!'
            })
          } else {
            this.dialogLoading = true
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_cost_project/cost_id/' + this.expenseObj.cost_id, {
              cost_desc: this.cost_desc_edit,
              cost_type: this.page,
              update_by: this.MeData[0].perid,
            }, {
              headers: {
                'Content-Type': 'application/json',
              }
            }).then(async res => {
              if (res.data) {
                this.cost_desc_edit = ''
                const resExpense = await this.initExpenseData({
                  cost_type: this.TypeProject
                })
                if (resExpense) {
                  this.dialogLoading = false
                  this.dialogEdit = false
                  this.ChooseProcess(this.page)
                } else {
                  this.dialogLoading = false
                }
                this.$swal.fire({
                  icon: 'success',
                  title: 'แก้ไขข้อมูลสำเร็จ !!'
                })
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถแก้ไขข้อมูลได้ โปรดลองอีกครั้ง !!'
                })
              }
            })
          }
        }
      })
    },
    editData(item) {
      this.expenseObj = null
      this.cost_desc_edit = ''
      this.expenseObj = item
      this.cost_desc_edit = item.cost_desc
      this.dialogEdit = true
    },
    delData(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบรายละเอียดค่าใช้จ่าย : " + item.cost_desc + " ใช่หรือไม่ ??",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.dialogLoading = true
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_cost_project/cost_id/' + item.cost_id, {
            update_by: this.MeData[0].perid,
            active: '0'
          }, {
            headers: {
              'Content-Type': 'application/json',
            }
          }).then(async res => {
            if (res.data) {
              this.cost_desc_edit = ''
              const resExpense = await this.initExpenseData({
                cost_type: this.TypeProject
              })
              if (resExpense) {
                this.dialogLoading = false
                this.ChooseProcess(this.page)
              } else {
                this.dialogLoading = false
              }
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ !!'
              })
            } else {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถแก้ไขข้อมูลได้ โปรดลองอีกครั้ง !!'
              })
            }
          })
        }
      })
    },
    ChooseProcess(page) {
      this.page = null
      this.page = page
      this.expenseDataDump = []
      if (page == '1') {
        this.changeTypeProject({
          type: '1'
        })
        this.changeColor({
          color: '#1976d2'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp1
        })
        this.dialogProcess = false
      } else {
        this.changeTypeProject({
          type: '2'
        })
        this.changeColor({
          color: '#004D40'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp2
        })
        this.dialogProcess = false
      }
      this.initExpenseData({
        cost_type: this.TypeProject
      }).then(res => {
        if (res) {
          this.expenseDataDump = this.expense_Data.length > 0 ? this.expense_Data.filter(item => item.cost_type == page) : []
        }
      })
    },
    async init() {
      const resExpense = await this.initExpenseData({
        cost_type: this.TypeProject
      })
      if (resExpense) {
        this.dialogProcess = true
      }
    }
  },
  mounted() {
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    // this.changeColor({
    //   color: '#004D40'
    // })
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '21'
        })
        this.getMenuPermissData().then(async res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '21' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.maintain = false
              this.dialogLoading = true
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(resAdmin => {
                if (resAdmin) {
                  this.PermissionAdmin.map((Per_i, idx) => {
                    if (Per_i.permission_id == '16000') {
                      this.CheckAdmin = true
                      this.dialogLoading = false
                      this.init()
                    } else {
                      this.dialogLoading = false
                      if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                        this.$router.push('/')
                      }
                    }
                  })
                } else {
                  this.getPermissionUserData({
                    perid: this.MeData[0].perid
                  }).then(resUser => {
                    if (resUser) {
                      this.Permission.map((Per_i, idx) => {
                        if (Per_i.permission_id == '10000') {
                          this.CheckSubAdmin = true
                          this.dialogLoading = false
                          this.init()
                        } else {
                          this.dialogLoading = false
                          if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                            this.$router.push('/')
                          }
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      this.CheckSubAdmin = false
                      this.CheckAdmin = false
                      this.$router.push('/')
                    }
                  })
                }
              })
            } else {
              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '21' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '21')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '21' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '21')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      this.dialogLoading = false
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>

</style>
